import { useTranslation } from 'react-i18next';
import { StatusPill } from '@/components/shared/StatusPill';

export interface SupplierOutChipProps {
  /** The supplier no longer sells the blank, not just out of stock for now. */
  discontinued?: boolean;
  className?: string;
}

/**
 * BLU-1526: why a just-in-time blank reads 0: its supplier is out of it
 * ("Out at supplier"), or no longer sells it ("Discontinued at supplier").
 * Drawn with the shared `StatusPill`, tone `error`, like the Order and wait
 * "Out at {supplier}" chip, so the words carry the state and colour never
 * stands alone. The supplier is not named: the row says what is out, and the
 * server tells only the floor owner that it is.
 */
export function SupplierOutChip({ discontinued = false, className }: SupplierOutChipProps) {
  const { t } = useTranslation('inventory');
  return (
    <StatusPill tone="error" className={className}>
      {discontinued ? t('supply.discontinuedAtGeneric') : t('supply.outAtGeneric')}
    </StatusPill>
  );
}
